import React, { useState } from "react";
import weight from "../../../../../assets/Images/weigth.svg";
import Age from "./Age";

function Weight() {
  const [showAge, setShowAge] = useState(false);
  const [age, setAge] = useState("");

  const handleFindAgeClick = () => {
    setShowAge(!showAge);
  };

  const handleInputChange = (event) => {
    const { value } = event.target;
    setAge(value);
  };

  return (
    <>
      {showAge ? (
        <Age /> // Render the new panel when showPlanPanel is true
      ) : (
        <div className="plan-panel">
          <div className="d-flex justify-content-start  flex-column align-items-start">
            <label htmlFor="" className="weight-heading heavy">
              What is your weight ?
            </label>
            <input
              className="weight-input"
              type="text"
              placeholder="Weight"
              name="weight"
              value={age}
              onChange={handleInputChange}
            />
            <button
              className={`started_btn semi-bold d-flex mt-5 ${
                !age ? "disabled" : ""
              }`}
              onClick={handleFindAgeClick}
              disabled={!age}
            >
              Next
            </button>
          </div>
          <div>
            <img className="weight-img" src={weight} alt="weight-icon" />
          </div>
        </div>
      )}
    </>
  );
}

export default Weight;
